const INTERNAL_DASH_PROMPT_PREFIXES = [
  "Add ONE new tile to the dashboard,",
  "Edit ONE tile in the dashboard at path `",
  "Refresh the data in this dashboard.",
  "Uppdatera datan i denna dashboard.",
  "Aktualisiere die Daten in diesem Dashboard.",
  "Päivitä tämän kojelaudan tiedot.",
  "Oppdater dataene i dette dashboardet.",
] as const

/** True for implementation prompts dispatched by Dash UI controls. */
export function isInternalDashPrompt(value: string | null | undefined): boolean {
  const prompt = value?.trimStart()
  if (!prompt) return false
  return INTERNAL_DASH_PROMPT_PREFIXES.some((prefix) => prompt.startsWith(prefix))
}
